import type {BettingAdPromotionDomainModel} from "./promotion/betting-ad.promotion.domain-model";
import {BaseDomainDataSource} from "../../../infrastructure/models/base-domain-data-source";
import {BettingAdBookmakerDomainModel} from "./bookmaker/betting-ad.bookmaker.domain-model";

export class BettingAdDataSource extends BaseDomainDataSource {
  promotions: Array<BettingAdPromotionDomainModel>;
  boosts: Array<BettingAdBookmakerDomainModel>;
  bookmakers: Map<Number, BettingAdBookmakerDomainModel>;

  constructor(model, promotions: Array<BettingAdPromotionDomainModel>, boosts: Array<BettingAdBookmakerDomainModel>, bookmakers: Map<Number, BettingAdBookmakerDomainModel>) {
    super(model);

    this.promotions = promotions;
    this.boosts = boosts;
    this.bookmakers = bookmakers;
  }
}